import { useState } from 'react'

import { TIME_INPUT_FORMAT_HINT, TimeInput } from '../../DateTime'
import { Component, ComponentProps } from '../Component'
import { boolean, controls, text, time } from '../Controls'

export function TimeInputUsage() {
  const [props, setProps] = useState(() =>
    controls() //
      .add(boolean('disabled', false))
      .add(text('formatHint', TIME_INPUT_FORMAT_HINT))
      .add(text('label', 'Time input'))
      .add(time('maxValue', null))
      .add(time('minValue', null))
      .add(text('placeholder', 'Select time'))
      .add(time('value', null))
  )

  function handleChange(nextYear) {
    setProps(controls => controls.setValue('value', nextYear))
  }

  return (
    <>
      <Component
        {...props.getValues()}
        Component={TimeInput}
        name='TimeInput'
        onChange={handleChange}
      />
      <ComponentProps name='TimeInput' value={props} onChange={setProps} />
    </>
  )
}
